// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"62":"brand-rigging","155":"brand-danfloss","801":"brand-arg"}[chunkId] || chunkId) + "." + {"62":"c6055505","148":"90076712","155":"b8d3fff3","217":"47f725f9","765":"702f00ef","801":"e390e972","888":"176a3f56","934":"c06d18c1"}[chunkId] + ".chunk.js";
};